import { render, staticRenderFns } from "./NotOptimizedViewportModal.vue?vue&type=template&id=3faee863&scoped=true&"
import script from "./NotOptimizedViewportModal.vue?vue&type=script&lang=js&"
export * from "./NotOptimizedViewportModal.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/document_viewport_modal.scss?vue&type=style&index=0&id=3faee863&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faee863",
  null
  
)

export default component.exports